/* global mixpanel */

export default function addIdentify (profileId) {
  mixpanel.identify(profileId)
}



// WEBPACK FOOTER //
// ./app/mixpanel/identify.js